import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

// import GenericButton from 'GenericButton';
import { SORT_DIRECTION, CROSSTAB_VIEWER_GRID_TYPE } from '../../../util/CrosstabUtils';

import downArrowIconWhite from '../../../images/down_arrow_white.png';
import upArrowIconWhite from '../../../images/up-arrow_white.png';

export default class CrosstabViewerGridHeadCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropDown: SORT_DIRECTION.NONE,
      selectedDropdownColumn: '',
    };
  }

  onPrivateEyeSort = () => {
    let sortOrder = SORT_DIRECTION.DESC;
    if (
      this.props.sortColumnIndex === this.props.columnIndex &&
      this.props.sortKey === this.props.def.key
    ) {
      switch (this.props.sortOrder) {
        case SORT_DIRECTION.DESC:
          sortOrder = SORT_DIRECTION.ASC;
          break;
        case SORT_DIRECTION.ASC:
          sortOrder = SORT_DIRECTION.NONE;
          break;
        default:
          sortOrder = SORT_DIRECTION.DESC;
      }
    }
    this.props.onSort(sortOrder, this.props.def.key, this.props.columnIndex);
  };

  renderDropdown = () => (
    <div
      className={`crosstabViewerGrid-dropdown-content ${
        this.state.showDropDown !== SORT_DIRECTION.NONE ? 'show' : ''
      }`}
    >
      <button className="sortButton" title="SORT DESCENDING">
        <span>{String.fromCharCode(9650)}</span> SORT DESCENDING
      </button>
      {this.props.cellElementList.map(cellElement => (
        <Link
          className={
            this.state.selectedDropdownColumn === this.props.cellIndex &&
            this.props.sortKey === cellElement.key &&
            this.props.sortOrder === this.state.showDropDown
              ? 'selected'
              : ''
          }
          key={cellElement.key}
          onMouseDown={() =>
            this.props.onSort(
              this.state.showDropDown,
              cellElement.key,
              this.props.cellIndex,
            )
          }
        >
          {cellElement.label}
        </Link>
      ))}
      <Link
        key={SORT_DIRECTION.NONE}
        onMouseDown={() => this.props.onSort(SORT_DIRECTION.NONE)}
      >
        None
      </Link>
    </div>
  );
  checkDDNHCS(val) {
    const { selectedKPIsTitle, allSelectedKPIsInfo } = this.props;
    let ddNHCS = false;
    for (const key in selectedKPIsTitle) {
      if (
        selectedKPIsTitle[key] === val &&
        allSelectedKPIsInfo[key] &&
        allSelectedKPIsInfo[key].modeled
      ) {
        ddNHCS = allSelectedKPIsInfo[key].modeled;
      }
    }
    return ddNHCS;
  }

  renderCrosstabSortButtons = () => (
    <div className="crosstabViewerGrid-sort-btns">
      <button
        name={String.fromCharCode(9650)}
        className={`crosstabViewerGrid-arrows ${
          this.state.selectedDropdownColumn === this.props.cellIndex &&
          this.props.sortOrder === SORT_DIRECTION.ASC
            ? 'selected'
            : ''
        }`}
        onClick={() =>
          this.setState({
            showDropDown:
              this.state.showDropDown === SORT_DIRECTION.ASC
                ? SORT_DIRECTION.NONE
                : SORT_DIRECTION.ASC,
          })
        }
        onBlur={() =>
          this.setState({
            showDropDown: SORT_DIRECTION.NONE,
            selectedDropdownColumn: '',
          })
        }
      >
        <img src={upArrowIconWhite} className="sortArrow" alt="up sort arrow" />
      </button>
      <button
        name={String.fromCharCode(9660)}
        className={`crosstabViewerGrid-arrows ${
          this.state.selectedDropdownColumn === this.props.cellIndex &&
          this.props.sortOrder === SORT_DIRECTION.DESC
            ? 'selected'
            : ''
        }`}
        onClick={() =>
          this.setState({
            showDropDown:
              this.state.showDropDown === SORT_DIRECTION.DESC
                ? SORT_DIRECTION.NONE
                : SORT_DIRECTION.DESC,
          })
        }
        onBlur={() =>
          this.setState({
            showDropDown: SORT_DIRECTION.NONE,
            selectedDropdownColumn: '',
          })
        }
      >
        <img
          src={downArrowIconWhite}
          className="sortArrow"
          alt="up sort arrow"
        />
      </button>
      {this.renderDropdown()}
    </div>
  );

  render() {
    if (this.props.viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.TREND) {
      return (
        <th
          className="crosstabViewerGrid-sort-arrow-todo"
          data-tooltip
          aria-haspopup="true"
          title={this.props.def}
        >
          <div>
            <span className="crosstabViewerGrid-label">{this.props.def}</span>
          </div>
        </th>
      );
    }

    if (this.props.viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE) {
      return (
        <th
          className={`crosstabViewerGrid-sort-arrow-todo ${
            this.props.def.bgColorClass
          }`}
          data-tooltip
          aria-haspopup="true"
          title={`${this.props.def.label} ${
            this.props.def.isColumnLabelUpdated ? String.fromCharCode(185) : ''
          }`}
          onClick={this.onPrivateEyeSort}
        >
          <div>
            <span className="crosstabViewerGrid-label text-center">
              <img
                src={this.props.def.iconImage}
                className="labelIcon"
                alt="Icon"
              />
              <span className="crosstabViewerGrid-text">
                {this.props.def.label}
              </span>
            </span>
            {this.props.sortColumnIndex === this.props.columnIndex &&
            this.props.sortKey === this.props.def.key &&
            (this.props.sortOrder === SORT_DIRECTION.ASC ||
              this.props.sortOrder === SORT_DIRECTION.DESC) ? (
              <div className="crosstabViewerGrid-sort-btns">
                <div btnStyle="crosstabViewerGrid-arrows">
                  {String.fromCharCode(
                    this.props.sortOrder === SORT_DIRECTION.ASC ? 9650 : 9660,
                  )}
                </div>
              </div>
            ) : (
              <div />
            )}
          </div>
        </th>
      );
    }

    return (
      <th
        className="crosstabViewerGrid-sort-arrow-todo"
        data-tooltip
        aria-haspopup="true"
        title={`${this.props.def.label} ${
          this.props.def.isColumnLabelUpdated ? String.fromCharCode(185) : ''
        }`}
      >
        <div>
          <span className="crosstabViewerGrid-label">
            {
              this.checkDDNHCS(this.props.def.label)
                ? `${String.fromCharCode(10020)} ${this.props.def.label}`
                : this.props.def.label
            }
            <sup>{this.props.def.isColumnLabelUpdated ? '1' : ''}</sup>
          </span>
          {this.renderCrosstabSortButtons()}
        </div>
      </th>
    );
  }
}

CrosstabViewerGridHeadCell.propTypes = {
  def: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      isColumnLabelUpdated: PropTypes.bool,
    }),
  ]),
  cellIndex: PropTypes.number,
  cellElementList: PropTypes.arrayOf(PropTypes.object),
  viewerGridType: PropTypes.oneOf(Object.values(CROSSTAB_VIEWER_GRID_TYPE)),
  // selectedDropdownColumn: PropTypes.number,
  columnIndex: PropTypes.number,
  sortColumnIndex: PropTypes.number,
  onSort: PropTypes.func,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  key: PropTypes.string,
};
